// First screen for a signed-out parent: pick signup or login. Mirrors the
// student app's start screen (routes/index.tsx), in the parent app's blue.

import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { AppShell } from '@tupai/shell';
import { useAuthStore } from '@/store/auth-store';
import parentSplash from '@tupai/tokens/assets/scenes/parent-splash.svg';
import { useTranslation } from '@tupai/i18n/react';
import { signedInPath } from '@/lib/invite-flow';

export const Route = createFileRoute('/start')({
  beforeLoad: () => {
    if (useAuthStore.getState().token) throw redirect({ to: signedInPath(), replace: true });
  },
  component: StartPage,
});

function StartPage() {
  const navigate = useNavigate();
  const { t } = useTranslation('auth');

  return (
    <AppShell variant="fullscreen" tone="surface">
      <div className="flex flex-1 flex-col items-center justify-center px-6 text-center">
        <img src={parentSplash} alt="" className="mb-3 h-40 w-40" />
        <img src="/images/tupai-logo.png" alt="Tupai" className="mb-4 h-10 w-auto" />
        <h1 className="mb-2 font-display text-xl text-content">{t('startHeadline')}</h1>
        <p className="max-w-xs text-sm text-muted">{t('startSub')}</p>
      </div>

      {/* Signup leads as the one primary action; login is the quiet secondary. */}
      <div className="flex w-full max-w-sm flex-col items-center gap-3 self-center px-6 pb-8">
        <button onClick={() => navigate({ to: '/signup' })} className="cta-primary">
          {t('getStarted')}
        </button>
        <button onClick={() => navigate({ to: '/login' })} className="cta-secondary">
          {t('haveAccountCta')}
        </button>
      </div>
    </AppShell>
  );
}
